import { Navigate } from "react-router";
import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";
import { useProductSelectionContainer } from "../pages/ProductSelection/hooks/useProductSelectionContainer";

function RootRedirect() {
  const { institution } = useGetInstitutionQuery();
  const { showPersonalLoanOption, showCreditCardOption, showAutoLoanOption } =
    useProductSelectionContainer();

  const hasWebFlow = institution.lending_flows_enabled.includes("institution_site");
  const hasAnyProduct = showPersonalLoanOption || showCreditCardOption || showAutoLoanOption;

  if (!hasWebFlow) {
    console.error("Web lending flow is not enabled for this institution.");
    return <Navigate to="/error" replace />;
  }

  if (!hasAnyProduct) {
    console.error("No lending products are available for the institution.");
    return <ErrorScreen />;
  }

  // Always land on product selection, even for a single product: the Loan Portal
  // tile lives there, so skipping the page would leave returning applicants at
  // single-product institutions with no way to reach the portal.
  return <Navigate to="/product-selection" replace />;
}

export { RootRedirect };
